export const SERVICE = "admin/service";
export const FAQ = "admin/faq";

export const LEGAL = "admin/legal-info";
export const RESOURCES = "admin/resources";
export const FILEUPLAOD = "admin/upload";

export const ADDEDUCATION = "admin/education";

export const PRIVACYPOLICY = "admin/privacy";

export const TERMSCONDITIONS = "admin/term";

export const ABOUT = "admin/about";

export const PROMOTION = "admin/promotion";

export const SEARCH = "admin/category";

export const SUBCATEGORY = "admin/sub-category";
export const CASEREFERAL = "admin/case-referral";
export const QUESTIONS = "admin/question";

export const APPOINTMENTSREFERAL = "admin/appointment";

export const DASHBOARDS_STATS = "admin/appointment/reports/statistics";
export const DASHBOARDS_PEAK = "admin/appointment/reports/peak-periods";

export const SUBADMIN = "admin/users";
export const MENTOR = "/admin/mentors"
export const CONTACTUS = "/admin/contact-us"
export const BULKFILE = "/admin/users/bulk-user";
export const BULK_QUESTIONS = "admin/question/bulk-questions";
export const SUBSCRIPTION_PLAN = "admin/subscription-plan";
export const ADMIN_EARNING = "admin/earning";